import './CTA.css';

export default function CTA({ onOpenModal }) {
  return (
    <section className="cta" id="cta">
      <div className="cta-bg" />
      <div className="cta-wordmark reveal">
        <span>TAG</span><span>pdf</span>
      </div>
      <p className="cta-serif reveal">Your files. Your device. Your index.</p>
      <div className="cta-actions reveal">
        <button className="btn-primary" onClick={onOpenModal}>
          Join early Waitlist →
        </button>
      </div>
      <div className="cta-ver">v0.3.2 · Flutter · On-Device · No Account Required</div>
    </section>
  );
}
